
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 240 240","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M120 220c-55.228 0-100-44.772-100-100S64.772 20 120 20s100 44.772 100 100-44.772 100-100 100zm61.404-167.944C165.16 37.367 143.625 28.421 120 28.421s-45.16 8.946-61.404 23.635v135.888C74.84 202.633 96.375 211.579 120 211.579s45.16-8.946 61.404-23.635V52.056zM50.175 60.742C36.607 76.714 28.421 97.401 28.421 120c0 22.599 8.186 43.286 21.754 59.258V60.742zm139.65 0v118.516c13.568-15.972 21.754-36.659 21.754-59.258 0-22.599-8.186-43.286-21.754-59.258zM99.491 135H95v-30h5.07l5.667 15.722L111.561 105h4.878v30h-4.457v-20.237l-4.403 12.447h-3.807l-4.281-12.325V135zm27.228 0h-4.596v-30h4.596v30zm10.141 0h-4.456v-30h4.807l8.333 20.095V105H150v30h-4.596l-8.544-20.461V135zm-55.373-11.989l-8.346 9.532a3.893 3.893 0 01-5.495.365 3.892 3.892 0 01-.365-5.496l6.1-6.967-6.1-6.968a3.877 3.877 0 01-.965-2.563 3.894 3.894 0 016.825-2.567l8.346 9.532a3.896 3.896 0 010 5.132zm91.93 4.401a3.894 3.894 0 11-5.861 5.131l-8.346-9.532a3.887 3.887 0 01-.964-2.566c0-.916.321-1.832.964-2.566l8.346-9.532a3.895 3.895 0 015.861 5.131l-6.1 6.967 6.1 6.967z"}})])
          )
        }
      }
    